import { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const shimmerStyle = {
  background: 'linear-gradient(90deg, #f0f2f7 25%, #e2e6ef 50%, #f0f2f7 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.4s infinite',
  borderRadius: '4px',
};

const HorizontalBarChart = ({ data, loading = false, stacked = false, xTickCallback = (v) => '$' + v }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (loading || !data || !canvasRef.current) return;

    const existing = Chart.getChart(canvasRef.current);
    if (existing) existing.destroy();

    const chart = new Chart(canvasRef.current, {
      type: 'bar',
      data: data,
      options: {
        indexAxis: 'y',
        maintainAspectRatio: false,
        plugins: {
          legend: { display: stacked, position: 'bottom', labels: { font: { size: 11 }, boxWidth: 10, padding: 10 } },
          tooltip: {
            callbacks: {
              label: (c) => stacked ? `${c.dataset.label}: ${xTickCallback(c.parsed.x)}` : xTickCallback(c.parsed.x),
            },
          },
        },
        scales: {
          x: {
            stacked: stacked,
            ticks: {
              callback: xTickCallback,
              font: { size: 10 },
            },
            grid: { color: '#eef1f7' },
          },
          y: {
            stacked: stacked,
            ticks: { font: { size: 10 } },
            grid: { display: false },
          },
        },
      },
    });

    return () => chart.destroy();
  }, [data, loading, stacked]);

  if (loading) {
    return (
      <div className="chart-wrap-sm" style={{ display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'flex-end', padding: '10px 0' }}>
        {[80, 60, 95, 45, 70, 30].map((w, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ ...shimmerStyle, width: '60px', height: '10px', flexShrink: 0 }} />
            <div style={{ ...shimmerStyle, width: `${w}%`, height: '14px' }} />
          </div>
        ))}
      </div>
    );
  }

  if (!data) {
    return (
      <div className="chart-wrap-sm" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--muted)', fontSize: '12px' }}>
        No data available
      </div>
    );
  }

  return (
    <div className="chart-wrap-sm">
      <canvas ref={canvasRef}></canvas>
    </div>
  );
};

export default HorizontalBarChart;